var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoObject)?_c('div',{staticClass:"c-block-list-video",class:{
		'c-block-list-video--wide': _vm.fullWidthView,
	},attrs:{"id":("block-" + (_vm.$vnode.key))}},[(_vm.title)?_c('LongReadTarget',{staticClass:"relative mb-2xs/v z-10",attrs:{"container-id":("block-" + (_vm.$vnode.key)),"link-to-toc":{
			name: ("Spring til \"" + _vm.title + "\" i indholdsfortegnelsen"),
			attrs: {
				'data-focus-ignore': true,
			},
		},"title":_vm.title,"disabled":!_vm.showTitleInToc}},[_c('BaseH2',{attrs:{"id":("block-" + (_vm.$vnode.key) + "__title")},domProps:{"innerHTML":_vm._s(_vm.title)}})],1):_vm._e(),_vm._v(" "),_c('CookieInformationBlocker',{attrs:{"categories":[
				_vm.statistic && 'statistic',
				_vm.functional && 'functional',
				_vm.marketing && 'marketing' ].filter(Boolean)}},[_c('VideoPlayer',{staticClass:"c-block-list-video__video bg-theme",attrs:{"picker":_vm.videoObject,"aria-describedby":_vm.text ? ("block-" + (_vm.$vnode.key) + "__description") : null,"embed-on-play":""},scopedSlots:_vm._u([{key:"overlay",fn:function(ref){
			var overlay = ref.overlay;
			var service = ref.service;
return [_c('button',{class:[
						'group flex justify-center items-center',
						'relative w-full h-full',
						'duration-300 delay-200 ease-smooth-out',
						{
							'opacity-0 pointer-events-none':
								!overlay.isVisible,
						} ],attrs:{"id":("block-" + (_vm.$vnode.key) + "__overlay-button"),"aria-labelledby":_vm.overlayLabel,"aria-describedby":_vm.text ? ("block-" + (_vm.$vnode.key) + "__description") : null},on:{"click":function($event){$event.preventDefault();return (function () {
							service.play(overlay.hide);
							_vm.loading = true;
						}).apply(null, arguments)}}},[(service.poster)?_c('img',{class:[
							'absolute top-0 left-0',
							'w-full h-full object-cover',
							'mix-blend-luminosity opacity-20' ],attrs:{"src":service.poster}}):_vm._e(),_vm._v(" "),_c('BaseButton',{staticClass:"\n\t\t\t\t\t\t\trelative\n\t\t\t\t\t\t\tpx-sm/h\n\t\t\t\t\t\t\tbg-white\n\t\t\t\t\t\t\tgroup-hover:bg-theme-10\n\t\t\t\t\t\t\ttext-theme\n\t\t\t\t\t\t",attrs:{"tag":"div"},domProps:{"textContent":_vm._s('Afspil')}})],1)]}}],null,false,354046881)})],1),_vm._v(" "),(_vm.text)?_c('div',{class:[
			'mt-4xs/v >=768:mt-2xs/v',
			'text-gray-darker text-body-xs whitespace-pre-wrap' ],attrs:{"id":("block-" + (_vm.$vnode.key) + "__description")},domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }